module.exports = __webpack_public_path__ + "assets/media/4.de5fd40b.wav";